import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import format from 'string-template';

import FeedContext from '../../../../context/FeedContext';
import ToDoItem from '../../../../components/ToDoList/ToDoItem';

import {
  Container,
  Header,
  EmptyState,
  ErrorState,
  ClientGroup,
  StyledUserProfileCard,
} from './styles';
import texts from './texts.json';

const ConsolidatedToDoFeed = () => {
  const {
    consolidatedToDoGroups,
    hasConsolidatedToDoError,
  } = useContext(FeedContext);

  const renderPlaceholder = () => (hasConsolidatedToDoError
    ? <ErrorState>{texts.loadError}</ErrorState>
    : <EmptyState>{texts.emptyState}</EmptyState>);

  return (
    <Container>
      <Header>{texts.title}</Header>
      {consolidatedToDoGroups.length === 0
        ? renderPlaceholder()
        : consolidatedToDoGroups.map(({ clientId, userDoc, toDos }) => (
          <ClientGroup key={clientId}>
            <StyledUserProfileCard
              clientId={clientId}
              dataRow={{
                userName: userDoc?.name || texts.unknownClient,
                userAvatar: userDoc?.avatarUrl,
                serviceStartAt: userDoc?.serviceStartAt,
                postPaymentFormSubmittedAt: userDoc?.postPaymentFormSubmittedAt?.toDate(),
              }}
              subTitle={format(texts.todoCount, {
                count: toDos.length,
                plural: toDos.length === 1 ? '' : 's',
              })}
              hasPostPaymentFormAnswer={!!userDoc?.postPaymentFormSubmittedAt}
            />
            {toDos.map((todoItem) => (
              <ToDoItem key={todoItem.id} todoItem={todoItem} showCreatedInfo />
            ))}
          </ClientGroup>
        ))}
    </Container>
  );
};

export default observer(ConsolidatedToDoFeed);
